module.exports = __webpack_public_path__ + "assets/img/00020.7be6e8b6.png";